export default function isPaidAdActivated(paidAd) {
  return (
    paidAd &&
    paidAd.campaign_invitation &&
    (paidAd.campaign_invitation.state === 'accepted' ||
      // This is activated, but has failed onthe backend along the way. We need
      // Backend developer intervention.
      paidAd.campaign_invitation.state === 'failed' ||
      paidAd.campaign_invitation.state === 'pending')
  )
}
